module.exports = __webpack_public_path__ + "static/media/Points.bd2de643.mp3";